import type { BuildStatus } from '../api/client';
import { useI18n } from '../i18n';
import type { TranslationKey } from '../i18n/translations';

interface StatusMeta {
  key: TranslationKey;
  cls: string;
  dotCls: string;
}

const STATUS_META: Record<BuildStatus, StatusMeta> = {
  idle: { key: 'status.idle', cls: 'status-idle', dotCls: 'dot-idle' },
  uploading: { key: 'status.uploading', cls: 'status-building', dotCls: 'dot-building' },
  building: { key: 'status.building', cls: 'status-building', dotCls: 'dot-building' },
  success: { key: 'status.success', cls: 'status-ready', dotCls: 'dot-ready' },
  failed: { key: 'status.failed', cls: 'status-failed', dotCls: 'dot-failed' },
};

/** 状态翻译键，供表格等场景配合 t() 使用 */
export function statusKey(status: BuildStatus): TranslationKey {
  return STATUS_META[status]?.key ?? 'status.idle';
}

export default function StatusBadge({ status }: { status: BuildStatus }) {
  const { t } = useI18n();
  const meta = STATUS_META[status] ?? {
    key: 'status.idle' as TranslationKey,
    cls: 'status-idle',
    dotCls: 'dot-idle',
  };
  return (
    <span className={`status-badge ${meta.cls}`}>
      <span className={`status-dot ${meta.dotCls}`} />
      {t(meta.key)}
    </span>
  );
}
